// extracted by css-extract-rspack-plugin
export default {"content":"r9YBpVnpnY0ToMlQ","jsonBlock":"PRlqqkJYyIoW81Ij","copyButton":"gd2AWxG0oOQP634Z","jsonPre":"RJr5owXGbMspk0eL"};